import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MainTemplate from '@/components/MainTemplate.vue'
import router from '@/router'


export default /*@__PURE__*/_defineComponent({
  __name: 'TermsAndConditions',
  setup(__props) {

const handleAgree = () => {
  router.push('/fnol-form')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainTemplate, null, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleAgree, ["prevent"]),
        method: "post"
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "header" }, null, -1),
        _createElementVNode("div", { class: "form form-additional" }, [
          _createElementVNode("div", { class: "reading-text" }, [
            _createElementVNode("div", { class: "hspace" }),
            _createElementVNode("span", { class: "span1" }, "1．お客様に関する情報の取得・利用について"),
            _createElementVNode("br"),
            _createElementVNode("div", { class: "hspace" }),
            _createElementVNode("span", { class: "span2" }, "弊社は、本件事故の保険金請求に際して、お客様のお名前、ご連絡先、事故状況、車の損害状況やその所有者、おけがの容態などの個人情報について、円滑な事故解決、適正な保険金のお支払い、事故調査（医療機関、修理業者、警察・消防、事故当事者等に対する照会等を含みます。）、保険金不正請求等の犯罪防止・排除のために必要な範囲で取得・利用させていただきます。"),
            _createElementVNode("div", { class: "hspace" }),
            _createElementVNode("span", { class: "span1" }, "2．お客様に関する情報の第三者提供について"),
            _createElementVNode("div", { class: "hspace" }),
            _createElementVNode("span", { class: "span2" }, "弊社は、本件事故の保険金請求に際して、円滑な事故解決、適正な保険金のお支払い、事故調査、保険金不正請求等の犯罪防止・排除のため、取得したお客様の情報を下記の第三者などにお伝えすることがあります。"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "span2" }, "・事故当事者"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "span2" }, "・事故当事者の関係する保険会社"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "span2" }, "・保険契約者"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "span2" }, "・保険契約取扱代理店"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "span2" }, "・修理業者"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "span2" }, "・医療機関"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "span2" }, "・警察・消防"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "span2" }, "など"),
            _createElementVNode("div", { class: "hspace" })
          ]),
          _createElementVNode("input", {
            name: "__RequestVerificationToken",
            type: "hidden",
            value: "2k2O2_Wuq60TdQxYLz3dZ3ixwxmf1HHdzrPK21Yz6wtuYlkJT7AIiKYvEUB3sGRr6GrHLCq4kPeAqxRHp-9a8iAmJKwFdnZV8PgZsusQGZI1"
          }),
          _createElementVNode("div", { class: "btn_box" }, [
            _createElementVNode("input", {
              type: "submit",
              class: "btn btn-success",
              value: "同意する"
            })
          ])
        ], -1)
      ]), 32)
    ]),
    _: 1
  }))
}
}

})